import { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { apiUrl } from "../../config/config.js";
import { useNavigate } from "react-router-dom/dist/index.js";

function Dashboard() {
	const navigate = useNavigate();
	const [statsData, setStatsData] = useState([]);

	const [users, setUsers] = useState([]);
	const [events, setEvents] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const [usersResponse, eventsResponse] = await Promise.all([
					fetch(`${apiUrl}/users`, {
						method: 'GET',
						headers: { 'Content-Type': 'application/json' }
					}),
					fetch(`${apiUrl}/events`, {
						method: 'GET',
						headers: { 'Content-Type': 'application/json' }
					})
				]);

				if (usersResponse.ok) {
					const { data } = await usersResponse.json();
					setUsers(data || []);
				}

				if (eventsResponse.ok) {
					const { events } = await eventsResponse.json();
					setEvents(events || []);
				}
			} catch (error) {
				console.error('Error cargando datos:', error);
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, []);

	useEffect(() => {
		fetch("/assets/data/dashboard/stats.json")
			.then((res) => res.json())
			.then((result) => {
				setStatsData(result);
			});
	}, []);

	const counts = {
		"Usuarios": users.length,
		"Eventos": events.length,
	};

	if (loading) {
		return (
			<div className="text-center">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Cargando...</span>
				</div>
			</div>
		);
	}

	return (
		<div>
			<div className="row">
				{statsData &&
					statsData.length > 0 &&
					statsData.map((stat, index) => (
						<div className="col-xl-3 col-lg-6 " key={index}
							onClick={() => navigate(stat.navigate)}
							style={{ cursor: "pointer" }}>
							<Card className="mb-3">
								<CardBody>
									<div className="d-flex fw-bold small mb-3">
										<span className="flex-grow-1">{stat.title}</span>
									</div>
									<div className="row align-items-center mb-2">
										<div className="col-7">
											<h3 className="mb-0">{counts[stat.title]}</h3>
										</div>
									</div>
								</CardBody>
							</Card>
						</div>
					))}
			</div>
		</div>
	);
}

export default Dashboard;
